<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-row no-gutters>
        <v-col>
          <v-card class="pa-2 ma-2" outlined tile>
            <!-- toolbar -->
            <reference-tool-bar
              :title="options.title.main"
              :editedIndex="editedIndex"
              :createItemTitle="options.title.create"
              :formTitle="formTitle"
              :dialog="dialog"
              @save="save"
              @close="close"
              @open="open"
            >
              <template v-slot:formCreateEdit>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="options.editedItem.nameRu"
                    label="Наименование"
                    :hint="`Введите полное название организации`"
                    :rules="[rules.required, rules.min]"
                    required
                    autofocus
                  ></v-text-field>
                </v-flex>
                <!-- <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="options.editedItem.nameKz"
                    label="NameKz"
                    :hint="`Допускаются только буквы`"
                    :rules="[rules.required, rules.min]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="options.editedItem.nameEn"
                    label="NameEn"
                    :hint="`Допускаются только буквы`"
                    :rules="[rules.required, rules.min]"
                  ></v-text-field>
                </v-flex> -->
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="options.editedItem.bin"
                    label="БИН"
                    :hint="`Введите 12 цифр`"
                    :rules="[rules.required, rules.bin]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-select
                    v-model="regionSelect"
                    :hint="`Идентификатор региона - [${regionSelect.id}]`"
                    :items="regionList"
                    item-text="nameRu"
                    item-value="id"
                    label="Регион"
                    persistent-hint
                    return-object
                    single-line
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="options.editedItem.address"
                    label="Адрес"
                    :hint="`Введите юридический адрес организации`"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-select
                    v-model="statusSelect"
                    :hint="`Идентификатор статуса - [${statusSelect.id}]`"
                    :items="statusList"
                    item-text="nameRu"
                    item-value="id"
                    label="Статус"
                    persistent-hint
                    return-object
                    single-line
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-select
                    v-model="organizationTypeSelect"
                    :hint="
                      `Идентификатор типа организации - [${organizationTypeSelect.id}]`
                    "
                    :items="organizationTypeList"
                    item-text="nameRu"
                    item-value="id"
                    label="Тип организации"
                    persistent-hint
                    return-object
                    single-line
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    v-model="options.editedItem.phone"
                    label="Телефон горячей линии"
                    :hint="`Введите номер горячей линии организации`"
                    :rules="[rules.phone]"
                  ></v-text-field>
                </v-flex>
              </template>
            </reference-tool-bar>
            <!--Таблица с данными-->
            <reference-table
              :headers="options.headers"
              :items="options.data"
              @edit-item="editItem($event)"
              @remove-item="removeItem($event)"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import { Vue } from "vue-property-decorator";
import { get } from "vuex-pathify";
import { mapActions } from "vuex";
import { rules } from "@/util/rules";

export default Vue.extend({
  name: "ReferenceOrganization.vue",
  components: {
    ReferenceTable: () => import("@/components/reference/ReferenceTable.vue"),
    ReferenceToolBar: () =>
      import("@/components/reference/ReferenceToolBar.vue")
  },
  computed: {
    options: get("reference/optionsOrganization"),
    organizationTypeList: get("reference/getOrganizationTypes"),
    regionList: get("reference/getRegions"),
    statusList: get("reference/getStatus"),
    formTitle() {
      return this.editedIndex === -1 ? "Создать" : "Редактировать";
    }
  },
  data() {
    return {
      rules,
      dialog: false,
      editedIndex: -1,
      regionSelect: 0,
      statusSelect: 0,
      organizationTypeSelect: 0
    };
  },
  methods: {
    ...mapActions({
      fetchReference: "reference/fetchOrganizations",
      fetchOrganizationTypes: "reference/fetchOrganizationTypes",
      fetchStatus: "reference/fetchStatus",
      fetchRegion: "reference/fetchRegion"
    }),
    openDialog(isOpen) {
      this.dialog = isOpen;
    },
    initialize() {
      this.fetchStatus().then(result => {
        this.statusSelect = this.statusList.find(
          status => status.name == "Active"
        );
      });
      this.fetchRegion().then(result => {
        this.regionSelect = this.regionList[0];
      });
      this.fetchOrganizationTypes().then(result => {
        this.organizationTypeSelect = this.organizationTypeList.find(
          o => o.nameEn == "Organization"
        );
      });
      this.fetchReference();
    },
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.options.editedItem = Object.assign({}, this.options.defaultItem);
        this.organizationTypeSelect = this.organizationTypeList[0];
        this.statusSelect = this.statusList[0];
        this.regionSelect = this.regionList[0];
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      const model = {
        organizationTypeId: this.organizationTypeSelect.id,
        regionId: this.regionSelect.id,
        statusId: this.statusSelect.id,
        id: this.options.editedItem.id,
        nameRu: this.options.editedItem.nameRu,
        nameKz: this.options.editedItem.nameKz,
        nameEn: this.options.editedItem.nameEn,
        bin: this.options.editedItem.bin,
        address: this.options.editedItem.address,
        phone: this.options.editedItem.phone
      };
      if (this.editedIndex > -1) {
        this.$http.put(this.options.path.base, model).then(response => {
          if (response.text === "Ok") this.initialize();
        });
      } else {
        model.id = 0;
        this.$http.post(this.options.path.base, model).then(response => {
          if (response.text === "Ok") this.initialize();
        });
      }
      this.close();
    },
    editItem(item) {
      this.editedIndex = this.options.data.indexOf(item);
      this.options.editedItem = Object.assign({}, item);
      this.organizationTypeSelect = {
        id: item.organizationType.id,
        name: item.organizationType.NameRu
      };
      this.statusSelect = { id: item.status.id, name: item.status.NameRu };
      this.regionSelect = { id: item.region.id, name: item.region.NameRu };
      this.open();
    },
    removeItem(item) {
      if (confirm("Вы уверены что хотите удалить организацию?")) {
        const model = Object.assign({}, item);
        this.$http
          .delete(this.options.path.base, { data: model })
          .then(response => {
            if (response.status === "Ok") this.initialize();
          });
      }
    }
  },
  created() {
    this.initialize();
  }
});
</script>
